/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Social_Post_RenderInputs */

const cs_enum_social_post_render = /** @type {(inputs: Enum_Social_Post_RenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vykreslení sociálního příspěvku`)
};

const en_enum_social_post_render = /** @type {(inputs: Enum_Social_Post_RenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social post render`)
};

/**
* | output |
* | --- |
* | "Social post render" |
*
* @param {Enum_Social_Post_RenderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_social_post_render = /** @type {((inputs?: Enum_Social_Post_RenderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Social_Post_RenderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_social_post_render(inputs)
	return cs_enum_social_post_render(inputs)
});